"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleTrading = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeErrorConstants_1 = require("../../TradeUtils/TradeErrorConstants");
const react_1 = require("react");
const GetMinLimitFromSymbol = (limitType, symbol, price) => {
    var _a, _b, _c, _d;
    if (!symbol.limit) {
        return undefined;
    }
    let minAmount = 0;
    let minCost = 0;
    if ((_a = symbol.limit.amount) === null || _a === void 0 ? void 0 : _a.min) {
        minAmount = symbol.limit.amount.min;
    }
    if ((_b = symbol.limit.cost) === null || _b === void 0 ? void 0 : _b.min) {
        minCost = symbol.limit.cost.min;
    }
    if (limitType === "amount") {
        const result = trade_utils_lib_1.SafeDecimal.max(minAmount, price ? minCost / price : 0).toNumber();
        try {
            return trade_utils_lib_1.NumberCommonUtils.formatterDecimal(result, symbol.amount, trade_utils_lib_1.SafeDecimal.ROUND_CEIL).toNumber();
        }
        catch (e) {
            return undefined;
        }
    }
    else {
        const result = trade_utils_lib_1.SafeDecimal.max(minAmount * price, minCost).toNumber();
        const precision = trade_utils_lib_1.SafeDecimal.max((_c = symbol.precision) !== null && _c !== void 0 ? _c : 0, (_d = symbol.precisionCost) !== null && _d !== void 0 ? _d : 0).toNumber();
        try {
            return trade_utils_lib_1.NumberCommonUtils.formatterDecimal(result, precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL).toNumber();
        }
        catch (_e) {
            return undefined;
        }
    }
};
const GetMaxLimitFromSymbol = (limitType, symbol, price) => {
    var _a, _b;
    if (!symbol.limit) {
        return undefined;
    }
    let maxAmount = 0;
    let maxCost = 0;
    if ((_a = symbol.limit.amount) === null || _a === void 0 ? void 0 : _a.max) {
        maxAmount = symbol.limit.amount.max;
    }
    if ((_b = symbol.limit.cost) === null || _b === void 0 ? void 0 : _b.max) {
        maxCost = symbol.limit.cost.max;
    }
    if (limitType === "amount") {
        if (maxAmount && maxCost && price) {
            // 最大的最小值
            const minAmount = trade_utils_lib_1.SafeDecimal.min(maxAmount, maxCost / price).toNumber();
            return trade_utils_lib_1.NumberCommonUtils.formatterDecimal(minAmount, symbol.amount, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR).toNumber();
        }
        else if (maxAmount) {
            return trade_utils_lib_1.NumberCommonUtils.formatterDecimal(maxAmount, symbol.amount, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR).toNumber();
        }
        else if (maxCost && price) {
            const amount = new trade_utils_lib_1.SafeDecimal(maxCost).div(new trade_utils_lib_1.SafeDecimal(price)).toNumber();
            return trade_utils_lib_1.NumberCommonUtils.formatterDecimal(amount, symbol.amount, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR).toNumber();
        }
        return undefined;
    }
    else {
        if (maxAmount && maxCost && price) {
            // 最大的最小值
            const minCost = trade_utils_lib_1.SafeDecimal.min(maxAmount * price, maxCost).toNumber();
            return trade_utils_lib_1.NumberCommonUtils.formatterDecimal(minCost, symbol.precision, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR).toNumber();
        }
        else if (maxCost) {
            return trade_utils_lib_1.NumberCommonUtils.formatterDecimal(maxCost, symbol.precision, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR).toNumber();
        }
        else if (maxAmount && price) {
            const cost = new trade_utils_lib_1.SafeDecimal(maxAmount).mul(new trade_utils_lib_1.SafeDecimal(price)).toNumber();
            return trade_utils_lib_1.NumberCommonUtils.formatterDecimal(cost, symbol.precision, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR).toNumber();
        }
        return undefined;
    }
};
exports.SimpleTrading = {
    // 获取最小成交量
    getMinAmount(symbol, price) {
        return GetMinLimitFromSymbol("amount", symbol, new trade_utils_lib_1.SafeDecimal(price).toNumber());
    },
    getMinCost(symbol, price) {
        return GetMinLimitFromSymbol("cost", symbol, new trade_utils_lib_1.SafeDecimal(price).toNumber());
    },
    getMaxAmount(symbol, price) {
        return GetMaxLimitFromSymbol("amount", symbol, new trade_utils_lib_1.SafeDecimal(price).toNumber());
    },
    getMaxCost(symbol, price) {
        return GetMaxLimitFromSymbol("cost", symbol, new trade_utils_lib_1.SafeDecimal(price).toNumber());
    },
    checkPrice(price, symbol) {
        if (!price) {
            return false;
        }
        const priceNum = trade_utils_lib_1.NumberCommonUtils.formatterDecimal(price, symbol.precision).toNumber();
        // 是否在交易所规定价格区间内
        if (symbol.limit && symbol.limit.price) {
            if (symbol.limit.price.min && priceNum < symbol.limit.price.min) {
                return false;
            }
            if (symbol.limit.price.max && priceNum > symbol.limit.price.max) {
                return false;
            }
        }
        return true;
    },
    parsePriceSupportTrading(price, symbol, $st) {
        if (!price) {
            throw TradeErrorConstants_1.TradeErrorConstants.inputPrice($st);
        }
        const priceDecimal = trade_utils_lib_1.NumberCommonUtils.formatterDecimal(price, symbol.precision);
        const priceNum = priceDecimal.toNumber();
        // 是否在交易所规定价格区间内
        if (symbol.limit && symbol.limit.price) {
            if (symbol.limit.price.min && priceNum <= symbol.limit.price.min) {
                throw TradeErrorConstants_1.TradeErrorConstants.priceTooLow(symbol.limit.price.min, $st);
            }
            if (symbol.limit.price.max && priceNum >= symbol.limit.price.max) {
                throw TradeErrorConstants_1.TradeErrorConstants.priceTooHigh(symbol.limit.price.max, $st);
            }
        }
        return priceDecimal;
    },
    parseAmountSupportTrading(amount, symbol, price, $st) {
        if (!amount) {
            throw TradeErrorConstants_1.TradeErrorConstants.inputQuantity($st);
        }
        const amountDecimal = trade_utils_lib_1.NumberCommonUtils.formatterDecimal(amount, symbol.amount);
        const minAmount = this.getMinAmount(symbol, price || 0);
        const maxAmount = this.getMaxAmount(symbol, price);
        // 是否低于交易所要求最低交易量
        if (minAmount !== undefined && amountDecimal.lessThan(new trade_utils_lib_1.SafeDecimal(minAmount))) {
            throw TradeErrorConstants_1.TradeErrorConstants.lowAmount(`${minAmount} ${symbol.baseDisplay}`, $st);
        }
        if (maxAmount !== undefined && amountDecimal.greaterThan(new trade_utils_lib_1.SafeDecimal(maxAmount))) {
            throw $st("trade_error_high_amount", { amount: `${maxAmount} ${symbol.baseDisplay}` });
        }
        return amountDecimal;
    },
    parseCostSupportTrading(cost, symbol, price, $st) {
        if (!cost) {
            throw "no cost";
        }
        const costDecimal = trade_utils_lib_1.NumberCommonUtils.formatterDecimal(cost, symbol.precision);
        const minCost = this.getMinCost(symbol, price || 0);
        const maxCost = this.getMaxCost(symbol, price);
        // 是否低于交易所要求最低交易量
        if (minCost !== undefined && costDecimal.lessThan(new trade_utils_lib_1.SafeDecimal(minCost))) {
            throw TradeErrorConstants_1.TradeErrorConstants.lowCost(`${minCost} ${symbol.quote}`, $st);
        }
        if (maxCost !== undefined && costDecimal.greaterThan(new trade_utils_lib_1.SafeDecimal(maxCost))) {
            throw $st("trade_error_high_cost", { cost: `${maxCost} ${symbol.quote}` });
        }
        return costDecimal;
    },
    useInvestAndInvestPercent(price, invest, investPercent, side, available, symbol) {
        const isTextType = (0, react_1.useRef)(true);
        const lastInvest = (0, react_1.useRef)("");
        const lastPercent = (0, react_1.useRef)(undefined);
        (0, react_1.useMemo)(() => {
            isTextType.current = true;
            lastInvest.current = invest;
            if (!Number(available)) {
                lastPercent.current = 0;
                return;
            }
            const volume = new trade_utils_lib_1.SafeDecimal(invest).mul(new trade_utils_lib_1.SafeDecimal(price));
            let percent = 0;
            if (side === TradeAPILib_1.ExchangeOrderSide.buy) {
                percent = volume.div(new trade_utils_lib_1.SafeDecimal(available)).toNumber();
            }
            else {
                percent = new trade_utils_lib_1.SafeDecimal(invest).div(available).toNumber();
            }
            lastPercent.current = percent > 1 ? 1 : percent;
        }, [invest]);
        (0, react_1.useMemo)(() => {
            isTextType.current = false;
            if (!Number(available) || !Number(price)) {
                lastInvest.current = "";
                return;
            }
            lastPercent.current = investPercent;
            let amount = "";
            if (side === TradeAPILib_1.ExchangeOrderSide.buy) {
                amount = new trade_utils_lib_1.SafeDecimal(investPercent).mul(new trade_utils_lib_1.SafeDecimal(available)).div(new trade_utils_lib_1.SafeDecimal(price)).toString();
            }
            else {
                amount = new trade_utils_lib_1.SafeDecimal(investPercent).mul(new trade_utils_lib_1.SafeDecimal(available)).toString();
            }
            lastInvest.current = amount === "0" ? "" : trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(amount, symbol.amount);
        }, [investPercent]);
        (0, react_1.useMemo)(() => {
            isTextType.current = true;
            if (!Number(available) || !Number(price)) {
                lastPercent.current = 0;
                lastInvest.current = "";
                return;
            }
            const invest = new trade_utils_lib_1.SafeDecimal(lastInvest.current);
            const volume = invest.mul(new trade_utils_lib_1.SafeDecimal(price));
            let percent = 0;
            if (side === TradeAPILib_1.ExchangeOrderSide.buy) {
                percent = volume.div(new trade_utils_lib_1.SafeDecimal(available)).toNumber();
            }
            else {
                percent = invest.div(available).toNumber();
            }
            lastPercent.current = percent > 1 ? 1 : percent;
        }, [side, price, available]);
        if (isTextType.current) {
            return [lastInvest.current, lastPercent.current];
        }
        else {
            return [lastInvest.current, undefined];
        }
    },
    useTextAndSlider(textValue, sliderValue, min, max, isTextMul100 = false, textPrecision = 4) {
        const isTextType = (0, react_1.useRef)(true);
        const lastInvest = (0, react_1.useRef)("");
        const lastPercent = (0, react_1.useRef)(undefined);
        const [minValue, maxValue] = (0, react_1.useMemo)(() => {
            return [new trade_utils_lib_1.SafeDecimal(min), new trade_utils_lib_1.SafeDecimal(max)];
        }, [min, max]);
        (0, react_1.useMemo)(() => {
            isTextType.current = true;
            lastInvest.current = textValue;
            let value = new trade_utils_lib_1.SafeDecimal(textValue);
            if (isTextMul100) {
                value = value.div(100);
            }
            if (value.lessThan(minValue)) {
                value = minValue;
            }
            else if (value.greaterThan(maxValue)) {
                value = maxValue;
            }
            lastPercent.current = value.toNumber();
        }, [textValue]);
        (0, react_1.useMemo)(() => {
            let numberResult = new trade_utils_lib_1.SafeDecimal(sliderValue);
            isTextType.current = false;
            if (numberResult.lessThan(minValue)) {
                numberResult = minValue;
            }
            else if (numberResult.greaterThan(maxValue)) {
                numberResult = maxValue;
            }
            lastPercent.current = numberResult.toNumber();
            const text = isTextMul100
                ? trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(numberResult.mul(100), textPrecision)
                : trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(numberResult, textPrecision);
            lastInvest.current = text === "0" ? "" : text;
        }, [sliderValue]);
        (0, react_1.useMemo)(() => {
            isTextType.current = true;
            let value = new trade_utils_lib_1.SafeDecimal(lastInvest.current);
            if (isTextMul100) {
                value = value.div(100);
            }
            if (value.lessThan(minValue)) {
                value = minValue;
            }
            else if (value.greaterThan(maxValue)) {
                value = maxValue;
            }
            lastPercent.current = value.toNumber();
        }, [minValue, maxValue, isTextMul100]);
        if (isTextType.current) {
            return [lastInvest.current, lastPercent.current];
        }
        else {
            return [lastInvest.current, undefined];
        }
    },
};
